import { expandedWarrantyTreatmentZodSchema } from "@redotech/redo-model/split";
import { object, string } from "zod/v4";

export const getExpandedWarrantyTreatment = {
  name: "getExpandedWarrantyTreatment" as const,
  input: object({ desiredTreatmentId: string().optional() }),
  output: object({
    expandedWarrantyTreatment: expandedWarrantyTreatmentZodSchema.optional(),
  }),
};
